import { Button, Tile } from '@op/opds.opux';
import { Message, useMessage } from '@messageformat/react';
import { space } from '@op/opds-tokens';

interface Props {
  isPersonCustomer: boolean;
}

const StartStockInvestingInfo = (props: Props): JSX.Element => {
  const { isPersonCustomer } = props;
  const openEquityLink = useMessage('startInvesting_openEquity_link');
  const openBookEntryLink = useMessage('startInvesting_openBookEntry_link');
  const corporateOpenBookEntryLink = useMessage(
    'corporate_startInvesting_openBookEntry_link',
  );
  return (
    <Tile style={{ flexGrow: 1, minHeight: '440px' }}>
      <p className="recommendationcomponent-title" style={{ paddingTop: space.small }}>
        <Message id="startInvesting_start" />
      </p>
      <p style={{ paddingTop: space.xxs }}>
        <Message id="startInvesting_stocks" />
      </p>
      <div style={{ display: 'flex', paddingTop: space.small }}>
        <div style={{ paddingRight: space.small }}>
          <p className="stockinvest-numberCircle">1</p>
        </div>
        <div style={{}}>
          <p className="fundcomponent-body medium">
            <Message id="startInvesting_openEquityOrBookEntry" />
          </p>
          <p
            className="fundcomponent-body"
            style={{ paddingTop: space.xxs, overflow: 'hidden' }}
          >
            <Message id="startInvesting_servicePackage" />
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', paddingTop: space.small }}>
        <div style={{ paddingRight: space.small }}>
          <p className="stockinvest-numberCircle">2</p>
        </div>
        <div style={{}}>
          <p className="fundcomponent-body medium">
            <Message id="startInvesting_study" />
          </p>
          <p
            className="fundcomponent-body"
            style={{ paddingTop: space.xxs, overflow: 'hidden' }}
          >
            <Message id="startInvesting_information" />
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', paddingTop: space.small }}>
        <div style={{ paddingRight: space.small }}>
          <p className="stockinvest-numberCircle">3</p>
        </div>
        <div style={{}}>
          <p className="fundcomponent-body medium">
            <Message id="startInvesting_choose" />
          </p>
          <p
            className="fundcomponent-body"
            style={{ paddingTop: space.xxs, overflow: 'hidden' }}
          >
            <Message id="startInvesting_diversify" />
          </p>
        </div>
      </div>

      <div style={{ textAlign: 'center' }}>
        {isPersonCustomer && (
          <>
            <Button
              href={openEquityLink}
              style={{ marginTop: space.default, marginRight: space.xs }}
            >
              <Message id="startInvesting_openEquity" />
            </Button>
            <Button
              href={openBookEntryLink}
              style={{ marginTop: space.default, marginLeft: space.xs }}
            >
              <Message id="startInvesting_openBookEntry" />
            </Button>
          </>
        )}
        {!isPersonCustomer && (
          <Button href={corporateOpenBookEntryLink} style={{ marginTop: space.default }}>
            <Message id="startInvesting_openBookEntry" />
          </Button>
        )}
      </div>
    </Tile>
  );
};
export default StartStockInvestingInfo;
